import classnames from "classnames";
import React from "react"
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { useStore } from "store";
import css from "./Ring.module.css"

function Ring({ data }) {
    const selectedRing = useStore(state => state.ring)
    const setRing = useStore(state => state.setRing)
    const { i18n } = useTranslation()
    const t = useStore(state => state.translations)

    return (
        <Row className={css.scrollBlock}>
            {data.length > 0 ? data.map(([key, ring]) => (
                <Col
                    key={key}
                    sm="3"
                    xs="2"
                    className={classnames(
                        css.selectionWrapper,
                        "text-center mb-2 p-2",
                        selectedRing === key && css.active
                    )}
                    onClick={() => setRing(key)}
                >
                    <img
                        className={classnames(css.image, "mb-3")}
                        src={(ring.imageThumbnail && ring.imageThumbnail.url) ? ring.imageThumbnail.url : (ring.imageFront && ring.imageFront.url)}
                        alt=""
                    />
                    <p className="m-0">{!!ring[`label${i18n.language.toUpperCase()}`] ? ring[`label${i18n.language.toUpperCase()}`] : ring.label}</p>
                </Col>
            )) : (
                <Col><small className={classnames("mt-4", css.emptyText)}>{t.settings.ring.emptyData[i18n.language]}</small></Col>
            )}
        </Row>
    );
}

export default Ring;